export default "__VITE_ASSET__DsSWB_AI__"